import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { unitSystemsMap } from './constants'
import { UnitsState, UnitSystemKeys } from './types'

let localStorageUnitSystem: UnitSystemKeys | 'Default' =
  (localStorage.getItem('UNIT_SYSTEM') as UnitSystemKeys) ||
  ('Default' as const)

if (!Object.keys(unitSystemsMap).includes(localStorageUnitSystem))
  localStorageUnitSystem = 'Default' as const

export const initialUnitsState: UnitsState = {
  selected: localStorageUnitSystem
}

export const unitsSlice = createSlice({
  name: 'units',
  initialState: initialUnitsState,
  reducers: {
    setUnitSystem: (
      state,
      action: PayloadAction<UnitSystemKeys | 'Default'>
    ) => {
      localStorage.setItem('UNIT_SYSTEM', action.payload)
      return {
        ...state,
        selected: action.payload
      }
    }
  }
})

export const reducer = unitsSlice.reducer

export const { setUnitSystem } = unitsSlice.actions
